import DeliveryTime from './Components/DeliveryTime';
// @ts-ignore
import {
    ExperimentalOrderMeta,
    registerCheckoutBlock,
} from '@woocommerce/blocks-checkout';
// @ts-ignore
import { registerPlugin } from '@wordpress/plugins';
// @ts-ignore
import metadata from './block.json';
import './style.scss';
import { useState } from '@wordpress/element';
import { VendorDeliveryTimeData } from './types/DeliveryTIme';
// @ts-ignore
const settings = window.wc.wcSettings.getSetting( 'dokan_delivery_time_data' );

const dokanDeliveryTimeBlock = ( props ) => {
    const { checkoutExtensionData, extensions } = props;
    const { setExtensionData } = checkoutExtensionData;
    const {
        setValidationErrors,
        hasValidationErrors,
        getValidationError,
        clearValidationError,
        hideValidationError,
    } = props.validation;
    const errorId = 'dokan-delivery-time';
    const [ error, setError ] = useState( '' );

    const saveDeliveryTime = ( deliveryTime ) => {
        const vendorDeliveryTime = Object.values( deliveryTime ).map(
            ( item: VendorDeliveryTimeData ) => {
                return {
                    vendor_id: item?.vendor_id ?? '',
                    store_name: item?.store_name ?? '',
                    delivery_date: item?.delivery_date ?? '',
                    selected_delivery_type:
                        item?.selected_delivery_type &&
                        item?.selected_delivery_type === 'pickup'
                            ? 'store-pickup'
                            : item?.selected_delivery_type &&
                              item?.selected_delivery_type === 'delivery'
                            ? 'delivery'
                            : '',
                    delivery_time_slot: item?.delivery_time_slot ?? '',
                    store_pickup_location: item?.store_pickup_location ?? '',
                };
            }
        );

        setExtensionData(
            'dokan_delivery_time',
            'vendor_delivery_time',
            vendorDeliveryTime
        );
    };

    const deliveryTimeHandle = ( data ) => {
        const vendorDeliveryTime = data?.data ?? {};

        setError(
            data.error && settings?.is_time_selection_required ? data.error : ''
        );
        if ( data.error && settings?.is_time_selection_required ) {
            setValidationErrors( {
                [ errorId ]: {
                    message: data.error,
                    hidden: false,
                },
            } );
        } else {
            clearValidationError( errorId );
        }

        saveDeliveryTime( vendorDeliveryTime );
    };

    const vendorInfo = settings?.vendorInfo ?? {};
    if (
        ! settings?.delivery_time_enabled ||
        ! Object.keys( vendorInfo ).length
    ) {
        return <></>;
    }

    return (
        <ExperimentalOrderMeta>
            <DeliveryTime
                extentionProps={ props }
                onChange={ deliveryTimeHandle }
                error={ error }
            />
        </ExperimentalOrderMeta>
    );
};

const render = () => '';

registerPlugin( 'dokan-delivery-time', {
    render,
    scope: 'woocommerce-checkout',
} );

registerCheckoutBlock( {
    metadata,
    component: dokanDeliveryTimeBlock,
} );
